import Vue from 'vue'

Vue.component('v-btn', () => import('../components/@ui/button/button.vue'))
